import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function Privacy_CAR_SERVICE_Data() {
  //const { state } = useLocation();
  //const { data } = state;
  //   const { data } = state;
  return (
    <>
      <div class="container">
        <h1>Privacy policy</h1>
        <p>
          This Privacy Policy applies to the app "CAR SERVICE Data". This page is
          going to inform you about the collection, use, and disclosure of
          Personal Information while using the "CAR SERVICE Data". If you choose to
          use the app, then you agree to the collection and use of information
          in relation to this policy.
        </p>
        <h2>Owner and Data Controller</h2>
        <p>ste aiv</p>
        <p>contact email: steve_aivaATicloud.com</p>
        <h2>Types of Data collected</h2>
        <p>
          We do not collect any type of data while you are using the app, apart
          from some error logs that are written when an error occurs. This error
          log file may include information such as your device name, operating
          system version, time and date and similar technical information.
        </p>
        <h2>Advertising</h2>
        <p>We do not use any kind of adevertisements.</p>
        <h2>External connections</h2>
        <p>
          This app does not use any external API connection. All user data, is stored in the user's device and is owned by the device. 
        </p>
        <h2>Changes to this privacy policy</h2>
        <p>
          We may make change to this privacy policy in the future. Any change
          will be reflected on this page. It is strongly recommended to check
          this page often, referring to the date of the last modification listed
          at the bottom.
        </p>
        <p></p>
        <h4>Latest update: Oct 25, 2023</h4>
      </div>
    </>
  );
}
